import React from "react"
import { BoxProps } from "@material-ui/core"
import FakeMaterialBox from "./FakeMaterialBox"
const FlexBox = React.forwardRef(({ ...rest }: BoxProps, ref) => (
    // hacky: Box does not have ref prop
    <FakeMaterialBox display="flex" {...{ ref }} {...rest} />
))

export default FlexBox
